import React from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { withRouter } from "react-router-dom";

import {Button, ImageDisplay} from '../../components';
import Colors from '../../constants/Colors';
import {NEWS_GET_IMAGE} from "./api/newsEndpoints";


class NewsComponent extends React.Component {

    render() {
        const {title, shortDescription, image, externalLink, uniqueId} = this.props.data;
        const {authToken, userEmail} = this.props;

        const { height, width } = Dimensions.get('window');

        return (
            <View style={{
                maxWidth: '90%',
                minWidth: '90%',
                alignItems: 'center',
                margin: 10,
                marginBottom: 40,
            }}>
                <ImageDisplay
                    imageUrl={NEWS_GET_IMAGE(uniqueId)}
                    authToken={authToken}
                    propsContainerStyle={{ height: 400, width: 400}}
                    propsImageStyle={{ height: 400, width: 400, borderRadius: 8 }}
                />

                <Text style={styles.titleStyle}>
                    {title}
                </Text>
                <Text style={styles.shortDescriptionStyle}>
                    {shortDescription}
                </Text>

                <Button
                    text={'Leia Mais'}
                    textPropsStyle={{ fontWeight: 'bold' }}
                    onPress={() => this.props.history.push('/news/reader', { newsData: this.props.data })}
                    // onPress={() => this.props.navigation.navigate('NewsReading', { newsData: this.props.data })}
                    containerPropsStyle={{
                        backgroundColor: Colors.buttonColor,
                        borderColor: Colors.buttonColor,
                        height: 50,
                        borderRadius: 4
                    }}
                />
            </View>
        )
    }
}

const styles = StyleSheet.create({
    imageStyle: {
        height: 200,
        width: 300,
        maxWidth: 300,
        maxHeight: 200,
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
    titleStyle: {
        textAlign: 'center',
        fontWeight: 'bold',
        color: Colors.inputFontColor,
        fontSize: 24,
        marginBottom: 10,
    },
    shortDescriptionStyle: {

        fontSize: 18,
        color: Colors.inputFontColor,
        marginBottom: 20,
    }
});

export default withRouter(NewsComponent);
